import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutUserAction } from "../../redux/actions/userActions";

import Logo from "../images/logo.png";
import Img1 from "../images/monitor.png";
import Img2 from "../images/user.png";
import Img3 from "../images/inventory.png";
import Avatar from "../images/avatar.png";
import Sort from "../images/sort.png";
import ExportImg from "../images/share.png";


const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const headerRef = useRef(null);

  const { isLoggedout, user, isAuthenticated } = useSelector(
    (state) => state.verifyEmailStore
  );



  const [showHeader, setShowHeader] = useState(false);

  const logoutUser = () => {
    dispatch(LogoutUserAction());
  };

  useEffect(() => {
    if (isLoggedout) {
      localStorage.setItem("email", "");
      navigate("/login");
    }
  }, [isLoggedout, navigate, isAuthenticated, user]);

  // Update device width responsiveness

  // Only apply hover expand on desktop




  const handleClick = () => {

    setShowHeader(false)
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setShowHeader(false);
      }
    }

    if (showHeader) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHeader]);



  return (
    <Fragment>
      {user?.role === 'Unauthorized' ?
        <section className="w-[100%] h-[100vh] flex-center" >
          <div className="p-[3vmax] flex-center flex-col w-[90%] lg:w-[60%]  bg-white shadow-1">
            <h2 className="text-[2.5vmax]  font-bold font-2" >🚫 Unauthorized Access</h2>
            <br />
            <p className="text-center" >
              This platform is restricted to admin use only. Unauthorized users are not permitted. If you are a Product Manager or Inventory Manager, please contact the admin to request access.
            </p>
            <br />
            <button className="bg-[image:var(--gradient)] text-white font-bold py-[0.8vmax] px-[2vmax] rounded-[2vmax] mt-[1vmax]"
              onClick={logoutUser}
            >Logout</button>
          </div>
        </section>
        :
        <section className="flex justify-between">
          {/* Sidebar */}

          <div
            ref={headerRef}
            className={`w-[100%] lg:w-[20%]  fixed h-[100vh] top-0 left-0 p-[1vmax] transition-all duration-300 z-[100000000]   ${showHeader ? "translate-x-[0] translate-y-[0] opacity-100" : "translate-x-[-100%] translate-y-[-100%] opacity-0"}`}
          >
            {/* Close button (mobile only) */}
            <button
              // onClick={() => setExpandHeader((prev) => !prev)}
              className="lg:hidden fixed top-[2vmax] right-[3vmax] z-[200] text-[2vmax]"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div className="w-full h-full bg-white rounded-[1vmax] shadow-1 flex flex-col items-center relative max-h-[100vh] overflow-auto my-scroll ">
              {/* Logo */}
              <div
                className={`sticky top-0 left-0 rounded-[1vmax] z-10 flex-center bg-white  "w-full"`}
              >
                <Link to={"/"} onClick={() => handleClick()} >
                  <img
                    src={Logo}
                    alt=""
                    className="w-[15vmax]  lg:w-[10vmax] py-[1vmax]"
                  />
                </Link>
              </div>

              {/* Links */}
              <div className="flex flex-col w-full">
                <div className="lg:text-[0.8vmax] pl-[1.4vmax] pt-[1vmax] uppercase text-slate-600">
                  Home
                </div>

                <Link
                  to={"/"}
                  className=" flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="dashboard"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img1}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">Dashboard</span>
                </Link>

                <Link
                  to={"/profile"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="profile"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img2}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">User Profile</span>
                </Link>

                <div className="text-[0.8vmax] pl-[1.4vmax] pt-[1vmax] uppercase text-slate-600">
                  Inventory
                </div>

                <Link
                  to={"/my-upc-scan-slip"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="UpcScanSlip"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img3}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">UPC Scans</span>
                </Link>
                <Link
                  to={"/export-excel-file"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="Export_Excel"
                  onClick={() => handleClick()}
                >
                  <img
                    src={ExportImg}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">Export Excel</span>
                </Link>
                <div className="text-[0.8vmax] pl-[1.4vmax] pt-[1vmax] uppercase text-slate-600">
                  Products
                </div>
                <Link
                  to={"/add-products"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="addProduct"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img3}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">Add Product</span>
                </Link>
                <Link
                  to={"/add-barcode-mapping"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="addBarcodeMapping"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img3}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">Barcode Mapping</span>
                </Link>
                <Link
                  to={"/import-products"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="importProducts"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img3}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">Import Products</span>
                </Link>
                <Link
                  to={"/product-catalog"}
                  className="flex gap-[2vmax] lg:gap-[0.8vmax] w-fit lg:w-[85%] items-center px-[3vmax] lg:px-[1vmax] mt-[1vmax] rounded-r-[3vmax] py-[0.8vmax] group overflow-hidden relative headerLinks activeHeaderLink"
                  id="productCatalog"
                  onClick={() => handleClick()}
                >
                  <img
                    src={Img3}
                    alt=""
                    className="w-[3vmax] lg:w-[1.5vmax] filter brightness-0 group-hover:filter-none"
                  />
                  <span className="text-[1.7vmax] font-bold lg:text-[1.1vmax]">Product Catalog</span>
                </Link>


                {/* User Info Bottom Section */}

                <div className="w-full bg-white p-[1vmax] sticky bottom-0 left-0 z-10">
                  <div
                    className={`bg-[var(--color-2-light)] rounded-[0.7vmax] flex items-center justify-between  p-[1vmax]`}
                  >
                    <div className="flex items-center">
                      <div className="w-[6vmax] h-[6vmax] lg:w-[3vmax] lg:h-[3vmax] rounded-full overflow-hidden">
                        <img
                          src={user?.avatar_url || Avatar}
                          alt=""
                          className="w-[6vmax] h-[6vmax] lg:w-[3vmax] lg:h-[3vmax] object-cover"
                        />
                      </div>
                      <div className="px-[1vmax]">
                        <h3 className="text-[1.7vmax] lg:text-[1vmax] font-bold">{user?.name}</h3>
                        <span className="text-[1.3vmax] lg:text-[0.7vmax] text-slate-700">
                          {user?.role}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={logoutUser}
                      className="text-[var(--color-2)] hover:translate-x-1 transition-transform duration-200 text-[2vmax] lg:text-[1.1vmax]"
                    >
                      <i className="fa-solid fa-arrow-right-from-bracket"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* Main Content */}
          <div
            className={` w-[100%]   transition-all duration-300`}
          >
            <div
              className={`w-[100%]  fixed top-0 right-0 py-[1vmax] pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax] transition-all duration-300 z-[100] bg-[var(--color-1)]`}
            >
              <div className="bg-white rounded-[1vmax] shadow-1 flex justify-between items-center">
                <button
                  className="ml-[1vmax] hover:translate-x-2 transition-transform duration-200 "
                  onClick={() => setShowHeader((prev) => !prev)}
                >
                  <img src={Sort} alt="" className="w-[3vmax] lg:w-[2vmax]" />
                </button>

                <div className="flex-center gap-[2vmax] relative">
                  <div className="rounded-[0.7vmax] flex-center py-[1vmax] pr-[1vmax]">
                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-full overflow-hidden">
                      <img
                        src={user?.avatar_url || Avatar}
                        alt=""
                        className="w-[2.5vmax] h-[2.5vmax] object-cover"
                      />
                    </div>
                    <div className="px-[1vmax]">
                      <h3 className="text-[1.6vmax] lg:text-[1vmax] font-3 font-bold">
                        {user?.name}
                      </h3>
                      <span className="text-[1.3vmax] lg:text-[0.9vmax] text-slate-700">
                        {user?.role}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pb-[9vmax] lg:pb-[7vmax] " >

            </div>
            <Outlet />


          </div>
        </section>

      }
    </Fragment>
  );
};

export default Home;
